import PropTypes from "prop-types";
import { HiOutlineInbox } from "react-icons/hi2";

const NoDataMessage = (props) => {
  const {
    icon,
    title = 'No Data Found',
    message,
    height = 500,
    action
  } = props;
  return (
    <div
      className="relative mt-4 flex h-full w-full rounded-xl border border-dashed border-gray-200 bg-gray-50/60"
      style={{ minHeight: height }}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6">
        {icon ? (
          icon
        ) : (
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gray-100">
            <HiOutlineInbox className="h-7 w-7 text-gray-400" />
          </div>
        )}
        {title && (
          <div className="text-center text-lg font-semibold tracking-tight text-gray-900">
            {title}
          </div>
        )}
        {message && (
          <div className="max-w-md text-center text-sm text-gray-500">
            {message}
          </div>
        )}
        {action && <div className="mt-2">{action}</div>}
      </div>
    </div>
  );
};

NoDataMessage.propTypes = {
    image: PropTypes.any,
    icon: PropTypes.element,
    title: PropTypes.string,
    message: PropTypes.string,
    height: PropTypes.number,
    action: PropTypes.any,
}

export default NoDataMessage;
